import { render, staticRenderFns } from "./effect-analysis-x.vue?vue&type=template&id=65352e5e&scoped=true"
import script from "./effect-analysis-x.vue?vue&type=script&lang=js"
export * from "./effect-analysis-x.vue?vue&type=script&lang=js"
import style0 from "./effect-analysis-x.vue?vue&type=style&index=0&id=65352e5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65352e5e",
  null
  
)

export default component.exports